exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body{font-family:HelveticaNeue,Helvetica Neue,Helvetica,Arial,sans-serif;color:#333}h1{margin-bottom:1.8rem}.app{display:flex;flex-direction:column;width:100%}.help-text{margin-top:20px;font-size:12px}#m68_navbar_top{font-style:italic;font-family:Garamond,Times New Roman,serif;font-size:large;padding-top:12px;margin-bottom:30px}#m68_navbar_top_nav{justify-content:center;flex:1 0 auto}#m68_nav_collapse_top.show{border-bottom:1px solid #ced4da;padding-bottom:15px}#m68_navbar_footer{font-size:smaller}.m68_article_teaser{float:left;text-align:left;padding-right:1.5625em;width:13em}figcaption{color:rgba(0,0,0,.5);font-size:x-small;width:13em;margin-left:.5em}.m68_breadcrumb{font-size:x-small;background-color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./src/assets/css/m68.css
// module id = 203
// module chunks = 0